export { EducateCompareModalPopup } from './EducateCompareModalPopup';